import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { PublisherCollectingSocietyUpdateStore } from "../../store";
import { InputReference } from "../../../common/controls";
import { CreateEntityDialog } from "../../../common/controls";
import { CollectiveManagementSocietyCreate } from "../../../collectiveManagementSociety/components/create/CollectiveManagementSocietyCreate";
import { CollectiveManagementSocietyCreateStore } from "../../../collectiveManagementSociety/store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PublisherCollectingSocietyUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  collectingSocietySelectedValue?: { displayId: string; id: string } | null;
  onCollectingSocietyChange?: (value: string) => void;
  onCollectingSocietySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  collectingSocietyOptions?: { displayId: string; id: string }[];
  collectingSocietyError?: string;
  cmsAccountNumber: string;
  cmsAccountNumberSelectedValue?: { displayId: string; id: string } | null;
  onCmsAccountNumberChange?: (value: string) => void;
  cmsAccountNumberError?: string;
  publisherCollectingSocietyUpdateStore: PublisherCollectingSocietyUpdateStore;
};

export const PublisherCollectingSocietyUpdateForm: React.FC<PublisherCollectingSocietyUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      onCollectingSocietySelected = () => {},
      collectingSocietyOptions = [],
      collectingSocietySelectedValue = null,
      collectingSocietyError,
      onCollectingSocietyChange = () => {},
      cmsAccountNumber = "",
      cmsAccountNumberError,
      onCmsAccountNumberChange = () => {},
      publisherCollectingSocietyUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="PublisherCollectingSociety"
              mode="update"
              values={{}}
              options={{ collectingSociety: collectingSocietyOptions }}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "collectingSociety":
                    onCollectingSocietySelected?.(valor);
                    break;
                  case "cmsAccountNumber":
                    onCmsAccountNumberChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={publisherCollectingSocietyUpdateStore.getCardErrors(
                "null"
              )}
              title={langStore.groupPublisherCollectingSocietyLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputReference
                  id="collectingSociety"
                  label={
                    langStore.PublisherCollectingSocietyCollectingSocietyLabel
                  }
                  autoFocus
                  error={Boolean(collectingSocietyError)}
                  helperText={
                    collectingSocietyError ||
                    publisherCollectingSocietyUpdateStore.warnings[
                      "collectingSociety"
                    ]?.message
                  }
                  selectedValue={collectingSocietySelectedValue}
                  onChange={(value: string) => onCollectingSocietyChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onCollectingSocietySelected(value)
                  }
                  options={collectingSocietyOptions}
                  description={
                    langStore.PublisherCollectingSocietyCollectingSocietyDescription
                  }
                  canCreate={rootStore.authStore.hasPermissions(
                    "collectiveManagementSociety_create"
                  )}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new CollectiveManagementSocietyCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <CollectiveManagementSocietyCreate
                          collectiveManagementSocietyCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewCollectiveManagementSociety"
                      cancelMethod="cancelNewCollectiveManagementSociety"
                    />
                  )}
                />
                <InputString
                  value={cmsAccountNumber}
                  error={Boolean(cmsAccountNumberError)}
                  warning={
                    !cmsAccountNumberError &&
                    Boolean(
                      publisherCollectingSocietyUpdateStore.warnings[
                        "cmsAccountNumber"
                      ]
                    )
                  }
                  helperText={
                    cmsAccountNumberError ||
                    publisherCollectingSocietyUpdateStore.warnings[
                      "cmsAccountNumber"
                    ]?.message
                  }
                  label={
                    langStore.PublisherCollectingSocietyCmsAccountNumberLabel
                  }
                  onChange={(value: string) => onCmsAccountNumberChange(value)}
                  description={
                    langStore.PublisherCollectingSocietyCmsAccountNumberDescription
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
